<div class="row col-12 p-0 m-0 main-page-section ">
  <div class="col-12 p-0 overview-icon profile-section">
    <div class="">
      <div class="breadcrumbs-section ">
        <span class="prev-page pt-1 " routerLink="/overview">Home</span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="curr-page  breadcrumbs-section-font">Profile</span>
      </div>
    </div>

    <div class="accor-padding-left" *ngIf="showCoAdmin">
      <div class="row pb-3">
        <div class="col-10 profile">
          Profile
        </div>
        <div class="col-2 log-out pointer-link" (click)="logout()">
          Log Out
        </div>
      </div>

      <!-- Profile sections (accordion removed for compatibility) -->
      <div class="accordian-panel">
        <!-- Section: Admin -->
        <div class="border-top pt-4 mt-2" id="toggle-1">
          <h5 class="admin pl-3 accordian-heading-color mb-0">Admin</h5>
          <div class="accordion-sub-data pl-4 pr-4 pb-4">
            <div class="col-12 row d-flex ">

              <div class="col-4 flex-column ">
                <div class="d-flex flex-column">
                  <span class="name">
                    Name
                  </span>

                  <span class="details">
                    {{taDetails?.name}}
                  </span>
                </div>

                <div class="d-flex flex-column pt-5 white-space">
                  <span class="name">
                    Mobile Number
                  </span>
                  <span class="details">
                    <span *ngIf="taDetails?.mobileNumber?.length<=10">+91-</span>{{taDetails?.mobileNumber}}
                  </span>
                </div>
              </div>
              <div class="col-4 flex-column ">
                <div class="d-flex flex-column white-space">
                  <span class="name">

                    Email ID
                  </span>
                  <span class="details">

                    {{taDetails?.emailId | lowercase}}
                  </span>
                </div>

                <div class="d-flex flex-column pt-4 white-space">
                  <span class="name">
                    Department
                  </span>
                  <span class="details">
                    {{taDetails?.department}}
                  </span>
                </div>

              </div>

              <div class="col-4 d-flex justify-content-end">
                <div class="circle-image-position" style="margin-top: 9px;">
                  <div class="circle">
                    <div class="circle-name">{{initials}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="">
                <div class="line "></div>
              </div>
              <div class="mt-5">
                <div class=" admin">
                  Access
                </div>
                <div class="entry-gate pt-3"> Entry Gate</div>
              </div>
              <div class="mt-4">
                <div class="pl-3 row d-flex mt-3 mr-3">
                  <ng-container class="" *ngFor="let eg of entryGate;let i=index">
                    <div class="chip" [ngClass]="(eg.selected)?'chip-selected':'chip-deselected'">
                      {{eg.accessPointName}}
                      <span class="closebtn">&times;</span>
                    </div>
                  </ng-container>


                </div>
              </div>
              <div class="show-all pt-3 pointer-link" (click)="showAccess(false)">Show all Access
                ({{accessPointList?.list.length}})</div> -->
          </div>
        </div>
        <!-- Section: Co-Admin 1 -->
        <!-- <div class="border-top pt-4 mt-2" *ngIf="userType != 'Parkite'" id="toggle-2">
          <h5 class="admin pl-3 accordian-heading-color mb-0">Co-Admin 1</h5>
          <div class="accordion-sub-data pl-4 pr-4 pb-4 pt-0">
            <div>
              <div *ngIf="add1">
                <div class="row">
                  <div class="col-10">
                    <div class="d-flex justify-textbox  mt-4">
                      <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                        [class.error-input]="fieldErrors.includes('name1')" class="search-line  pl-4 placeholder-text"
                        [(ngModel)]="fullname1" [placeholder]="!name ? 'Full Name' : ''" (click)="enterName('name1')"
                        (blur)="enterName('name1')" pattern="^[a-zA-Z ]{2,50}$" required
                        (ngModelChange)="inputModelChange(1,'name1')">
                      <label *ngIf="name" class="form-lable-email" for="mobile-emailid">Full Name</label>
                      <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                        [class.error-input]="fieldErrors.includes('email1')" class="search-line  pl-4 placeholder-text"
                        [(ngModel)]="emailId1" [placeholder]="!email ? 'Email ID' : ''" (click)="enterName('email1')"
                        (blur)="enterName('email1')" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                        required (ngModelChange)="inputModelChange(1, 'email1')">
                      <label *ngIf="email" class="form-lable-email" for="mobile-emailid">Email ID</label>
                    </div>
                    <div class="row" *ngIf="fieldErrors.length > 0">
                      <div class="col-5 field-error"><span *ngIf="fieldErrors.includes('name1')">Please enter valid
                          name</span>
                        <span *ngIf="fieldErrors.includes('name1len')">Please enter not more
                          than 50 characters</span>
                      </div>
                      <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('email1')">Please enter
                          valid
                          email</span> </div>
                    </div>
                    <div class="d-flex justify-textbox  mt-4">
                      <input type="tel" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                        class="search-line  pl-4 placeholder-text" [(ngModel)]="phoneNumber1"
                        [placeholder]="!mobile ? 'Mobile Number' : ''" (click)="enterName('mobile1')"
                        (blur)="enterName('mobile1')" pattern="^\d{10}$" (ngModelChange)="inputModelChange(1, 'phone1')"
                        [class.error-input]="fieldErrors.includes('phone1')" maxlength="10" required>
                      <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>
                      <div class="textbox-style pointer-link" style="position: relative;">
                        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                          [ngbPopover]="popContent1" triggers="manual" #p1="ngbPopover"
                          (click)="openPopover(p1);enterName('department')" placement="bottom"
                          popoverClass='dash-popover dashboard-popover'>
                          <input class="pt-3 pb-3 pl-4 input-width placeholder-text pointer-link"
                            [placeholder]="!dept ? 'Department' : ''" readonly [(ngModel)]="departmentName1" required
                            [class.error-input-dept]="fieldErrors.includes('dept1')">
                          <img src="/assets/images/Path.png" class="image-pos padding-left-image pr-1" loading="lazy" />
                        </div>
                        <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>

                        <div>
                          <ng-template #popContent1>
                            <div class="template p-0 m-0">
                              <div class="popupHeader">
                                <img src="../../assets/images/search.png">
                                <input type="text" placeholder='Search' [(ngModel)]="searchDept" />
                              </div>
                              <div class="dashboard-popover ">
                                <div class="d-flex justify-content-between">
                                  <div class="pl-3 pt-3 pr-3 pb-3 ">
                                    <div class="row pb-2"
                                      *ngFor="let dept of deptList | ListFilter: searchDept;let index =i"
                                      (click)="setDepartment1(dept);openPopover(p1);inputModelChange(1, 'dept1');enterName('department')">
                                      <div class="popover-content normal-font pl-3 email-width">
                                        {{dept.department}}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>

                    <div class="row" *ngIf="fieldErrors.length > 0">
                      <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('phone1')">Please enter valid
                          mobile number</span>
                      </div>
                      <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('dept1')">Please select a
                          department</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-2" style="margin: auto;">
                    <div class="profil-pic-holder" [style.background-color]="initials1 == '' ? '#fff': '#d2edf0'">
                      <img *ngIf="initials1 == ''" [src]="'/assets/images/profile/default-user.png'"
                        alt="coadmin profile image">
                      <div class="profil-pic-initial">
                        <span *ngIf="initials1 != ''">{{initials1}}</span>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="" *ngIf="add1  && isAdmin==true">
                  <div class="line "></div>
                </div>
                <div>
                  <div class="pt-4" *ngIf="add1  && isAdmin==true">
                    <span>
                      <button type="button " [disabled]="disableAdd" class="add-button"
                        (click)="addClick('add', 1)"><span class="add">Save</span></button>
                    </span>
                    <button type="button " class="cancel-button pl-3" (click)="cancelAdmin(1)"><span
                        class="cancel">Cancel</span></button>
                  </div>
                </div>
              </div>
              <div *ngIf="!add1">
                <div class="row">
                  <div class="col-10">
                    <div class="row d-flex ml-1">
                      <div class="col-4 d-flex flex-column">
                        <span class="name">
                          Co-Admin Name
                        </span>
                        <span class="details">
                          {{fullname1}}
                        </span>
                      </div>
                      <div class="col-7 d-flex flex-column">
                        <span class="name">
                          Email Id
                        </span>
                        <span class="details">
                          {{emailId1 | lowercase}}
                        </span>
                      </div>
                      <div class="col-1"></div>
                    </div>

                    <div class="row ml-1">
                      <div class="col-4 d-flex flex-column pt-5  white-space">
                        <span class="name">
                          Mobile Number
                        </span>
                        <span class="details">
                          +91-{{phoneNumber1}}
                        </span>
                      </div>
                      <div class="col-7 d-flex flex-column pt-5 ">
                        <span class="name">
                          Department
                        </span>
                        <span class="details">
                          {{departmentName1}}
                        </span>
                      </div>
                      <div class="col-1"></div>
                    </div>
                  </div>
          
                  <div class="col-2" style="margin: auto;">
                    <div class="profil-pic-holder" [style.background-color]="initials1 == '' ? '#fff': '#d2edf0'">
                      <img *ngIf="initials1 == ''" [src]="'/assets/images/profile/default-user.png'"
                        alt="coadmin profile image">
                      <div class="profil-pic-initial">
                        <span *ngIf="initials1 != ''">{{initials1}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="" *ngIf="isAdmin==true">
                      <div class="line "></div>
                    </div>
                    <div class="pt-4" *ngIf="isAdmin==true">
                      <span>
                        <button type="button " class="add-button btn" (click)="addClick('edit', 1);"><span
                            class="add">Edit</span></button>
                      </span>
                      <button type="button " class="cancel-button pl-3"
                        (click)="drawerClick(null); removeCoAdmin(1)"><span class="cancel">Remove Co-Admin
                          1</span></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Section: Co-Admin 2 -->
        <!-- <div class="border-top pt-4 mt-2" *ngIf="userType != 'Parkite'" id="toggle-3">
          <h5 class="admin pl-3 accordian-heading-color mb-0">Co-Admin 2</h5>
          <div class="accordion-sub-data pl-4 pr-4 pb-4 pt-0 coadmin-two">
            <div>
              <div *ngIf="add2" class="coadmin-2">
                <div class="row">
                  <div class="col-10">
                    <div class="d-flex justify-textbox  mt-4">
                      <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                        class="search-line  pl-4 placeholder-text" [(ngModel)]="fullname2" pattern="^[a-zA-Z ]{2,50}$"
                        [placeholder]="!name ? 'Full Name' : ''" (click)="enterName('name2')"
                        (blur)="enterName('name2')" (ngModelChange)="inputModelChange(2, 'name2')"
                        [class.error-input]="fieldErrors.includes('name2')" required>
                      <label *ngIf="name" class="form-lable-email" for="mobile-emailid">Full Name</label>
                      <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                        class="search-line  pl-4 placeholder-text" [(ngModel)]="emailId2"
                        [placeholder]="!email ? 'Email ID' : ''" (click)="enterName('email2')"
                        (blur)="enterName('email2')" required
                        pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                        (ngModelChange)="inputModelChange(2, 'email2')"
                        [class.error-input]="fieldErrors.includes('email2')">
                      <label *ngIf="email" class="form-lable-email" for="mobile-emailid">Email ID</label>
                    </div>
                    <div class="row" *ngIf="fieldErrors.length > 0">
                      <div class="col-5 field-error"><span
                          *ngIf="fieldErrors.includes('name2') && !fieldErrors.includes('name2len')">Please enter
                          valid
                          name</span>
                        <span *ngIf="fieldErrors.includes('name2len')">Please enter not more
                          than 50 characters</span>
                      </div>
                      <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('email2')">Please enter valid
                          email</span> </div>
                    </div>
                    <div class="d-flex justify-textbox  mt-4">
                      <input type="tel" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                        class="search-line  pl-4 placeholder-text" [(ngModel)]="phoneNumber2"
                        [placeholder]="!mobile ? 'Mobile Number' : ''" (click)="enterName('mobile2')"
                        (blur)="enterName('mobile2')" pattern="^\d{10}$" required maxlength="10"
                        (ngModelChange)="inputModelChange(2, 'phone2')"
                        [class.error-input]="fieldErrors.includes('phone2')">
                      <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>
                      <div class="textbox-style pointer-link" style="position: relative;">
                        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                          [ngbPopover]="popContent2" triggers="manual" #p2="ngbPopover"
                          (click)="openPopover(p2);enterName('department')" placement="bottom"
                          popoverClass='dash-popover dashboard-popover'>
                          <input class="pt-3 pb-3 pl-4 input-width placeholder-text pointer-link"
                            [placeholder]="!dept ? 'Department' : ''" [(ngModel)]="departmentName2" required
                            [class.error-input-dept]="fieldErrors.includes('dept2')" readonly>
                          <img src="/assets/images/Path.png" class="image-pos padding-left-image pr-1" loading="lazy" />
                          <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>
                          <ng-template #popContent2>
                            <div class="template p-0 m-0">
                              <div class="popupHeader">
                                <img src="../../assets/images/search.png">
                                <input type="text" placeholder='Search' [(ngModel)]="searchDept" />
                              </div>
                              <div class="dashboard-popover ">
                                <div class="d-flex justify-content-between">
                                  <div class="pl-3 pt-3 pr-3 pb-3 ">
                                    <div class="row pb-2"
                                      *ngFor="let dept of deptList | ListFilter: searchDept;let index =i"
                                      (click)="setDepartment2(dept);openPopover(p2);inputModelChange(2, 'dept2')">
                                      <div class="popover-content normal-font pl-3 email-width">
                                        {{dept.department}}
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="fieldErrors.length > 0">
                      <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('phone2')">Please enter valid
                          mobile number</span>
                      </div>
                      <div class="col-5 field-error"> <span *ngIf="fieldErrors.includes('dept2')">Please select a
                          department</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-2" style="margin: auto;">
                    <div class="profil-pic-holder" [style.background-color]="initials2 == '' ? '#fff': '#d2edf0'">
                      <img *ngIf="initials2 == ''" [src]="'/assets/images/profile/default-user.png'"
                        alt="coadmin profile image">
                      <div class="profil-pic-initial">
                        <span *ngIf="initials2 != ''">{{initials2}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="" *ngIf="add2 && isAdmin==true">
                  <div class="line "></div>
                </div>
                <div>
                  <div class="pt-4" *ngIf="add2 && isAdmin==true">
                    <span>
                      <button type="button " [disabled]="disableAdd" class="add-button btn"
                        (click)="addClick('add',2)"><span class="add">Save</span></button>
                    </span>
                    <button type="button " class="cancel-button pl-3" (click)="cancelAdmin(2)"><span
                        class="cancel">Cancel</span></button>
                  </div>
                </div>
              </div>
              <div *ngIf="!add2">
                <div class="row">

                  <div class="col-10">
                    <div class="row d-flex ml-1">
                      <div class="col-4 d-flex flex-column">
                        <span class="name">
                          Co-Admin Name
                        </span>

                        <span class="details">
                          {{fullname2}}
                        </span>
                      </div>
                      <div class="col-7 d-flex flex-column">
                        <span class="name">
                          Email Id
                        </span>
                        <span class="details">
                          {{emailId2 | lowercase}}
                        </span>
                      </div>
                      <div class="col-1"></div>
                    </div>

                    <div class="row ml-1">
                      <div class="col-4 d-flex flex-column pt-5  white-space">
                        <span class="name">
                          Mobile Number
                        </span>
                        <span class="details">
                          +91-{{phoneNumber2}}
                        </span>
                      </div>
                      <div class="col-7 d-flex flex-column pt-5 ">
                        <span class="name">
                          Department
                        </span>
                        <span class="details">
                          {{departmentName2}}
                        </span>
                      </div>
                      <div class="col-1"></div>
                    </div>
                  </div>

                  <div class="col-2" style="margin: auto;">
                    <div class="profil-pic-holder" [style.background-color]="initials2 == '' ? '#fff': '#d2edf0'">
                      <img *ngIf="initials2 == ''" [src]="'/assets/images/profile/default-user.png'"
                        alt="coadmin profile image">
                      <div class="profil-pic-initial">
                        <span *ngIf="initials2 != ''">{{initials2}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="" *ngIf="isAdmin==true">
                      <div class="line "></div>
                    </div>
                    <div class="pt-4" *ngIf="isAdmin==true">
                      <span>
                        <button type="button" class="add-button" (click)="addClick('edit',2);"><span
                            class="add">Edit</span></button>
                      </span>
                      <button type="button " class="cancel-button pl-3"><span class="cancel"
                          (click)="drawerClick(null);removeCoAdmin(2)">Remove Co-Admin
                          2</span></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      </div>

      <div *ngIf="userType != 'Parkite'" class="mt-4">
        <label class="admin">More Details</label>
        <div class="row col-12 d-flex" style="margin-bottom:5%">
          <!-- <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                Room Type
              </div>
              <div class="all pt-3">
                {{moreDetails?.roomType}}
              </div>
            </div>
          </div> -->
          <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                Credit points Used
              </div>
              <div class="all pt-3">
                {{claCredits?.spent}}/{{claCredits?.allocated}}
              </div>
            </div>
          </div>
          <!-- <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                2 Wheeler Parking
              </div>
              <div class="all pt-3">
                {{moreDetails?.twoWheelParking}}
              </div>
            </div>
          </div>
          <div class="mask mr-3 mb-3">
            <div class="p-3">
              <div class="room-type">
                4 Wheeler Parking
              </div>
              <div class="all pt-3">
                {{moreDetails?.fourWheelParking}}
              </div>
            </div>
          </div> -->
        </div>

      </div>
    </div>


    <div class="accor-padding-left" *ngIf="!showCoAdmin">

      <div class="d-flex justify-content-between pb-3 col-12 p-0" style="width: 88%;">
        <div class="profile">
          Your Profile
        </div>
        <div class="log-out d-flex justify-content-end pointer-link" (click)="logout()">
          Log Out
        </div>
      </div>

      <div class="content-box ">
        <div class="col-12 row d-flex ">

          <div class="col-4 flex-column ">
            <div class="d-flex flex-column">
              <span class="name">
                Name
              </span>

              <span class="details">
                {{taDetails?.name}}
              </span>
            </div>

            <div class="d-flex flex-column pt-5 white-space">
              <span class="name">
                Mobile Number
              </span>
              <span class="details">
                <span *ngIf="taDetails?.mobileNumber?.length<=10">+91-</span>{{taDetails?.mobileNumber}}
              </span>
            </div>
          </div>
          <div class="col-4 flex-column ">
            <div class="d-flex flex-column white-space">
              <span class="name">

                Email ID
              </span>
              <span class="details">

                {{taDetails?.emailId | lowercase}}
              </span>
            </div>

            <div class="d-flex flex-column pt-4 white-space">
              <span class="name">
                Your Role
              </span>
              <span class="details">Admin
                <!-- {{taDetails?.department}} -->
              </span>
            </div>

          </div>

          <div class="col-4 d-flex justify-content-end">
            <div class="circle-image-position" style="margin-top: 9px;">
              <div class="circle">
                <div class="circle-name">{{initials}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <ng-template *ngIf="userType != 'Parkite'" #adminAccess let-modal class="text-center custom-class" id="access">
    <div class="modal-height custom-class">
      <div class="modal-body c2 scroll-position">
        <img class="close" src="/assets/images/close-modal.png" (click)="modal.close('Save click')" loading="lazy" />

        <label class="admin">Access
        </label>
        <div class="entry-gate">Entry Gate</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let eg of entryGate;let i=index">
            <div class="chip" [ngClass]="(eg.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'entryGate',i)">
              {{eg.accessPointName}}
              <span class="closebtn" (click)="changeAccess(eg,'entryGate', i, true)">&times;</span>
            </div>
          </ng-container>

        </div>
        <div class="entry-gate pt-3">Meeting Room Access</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let mr of meetingRoomAccess;let i=index">
            <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'meetingRoomAccess',i)">
              {{mr.accessPointName}}
              <span class="closebtn" (click)="changeAccess(mr,'meetingRoomAccess', i, true)">&times;</span>
            </div>
          </ng-container>


        </div>
        <div class="entry-gate pt-3">Desk Access</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let mr of deskAccess;let i=index">
            <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'deskAccess',i)">
              {{mr.accessPointName}}
              <span class="closebtn" (click)="changeAccess(mr,'deskAccess', i, true)">&times;</span>
            </div>
          </ng-container>


        </div>
        <div class="entry-gate pt-3">Private Suite Access</div>
        <div class="pl-3 row d-flex mt-3 mr-3">
          <ng-container class="" *ngFor="let mr of privateSuiteAccess;let i=index">
            <div class="chip" [ngClass]="(mr.selected)?'chip-selected':'chip-deselected'"
              (click)="changeAccess(eg,'privateSuiteAccess',i)">
              {{mr.accessPointName}}
              <span class="closebtn" (click)="changeAccess(mr,'privateSuiteAccess', i, true)">&times;</span>
            </div>
          </ng-container>


        </div>

      </div>
    </div>
  </ng-template>